globalThis["__INTERFERE_RELEASE_SLUG__"] = "rel_10a933a1ef57e4ff";
globalThis["__INTERFERE_PROXY_MODE__"] = true;
globalThis["__INTERFERE_PUBLIC_KEY__"] = "build_placeholder";
import { init } from "@interfere/next/instrument-client";

init();